module.exports = __webpack_public_path__ + "static/img/double-wall-outlet-mk-2_256.1bad8a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-wall-outlet-mk-2_256.png
// module id = aKOy
// module chunks = 0